<template>
  <el-upload
    class="upload-demo"
    :action="uploadUrl"
    :on-exceed="handleExceed"
    :headers="{
      Authorization: token,
    }"
    :auto-upload="true"
    :on-success="handleSuccess"
    :on-error="handleError"
    :before-upload="beforeUpload"
    :show-file-list="false"
  >
    <el-button
      :type="butType.type || 'primary'"
      :icon="butType.icon || 'el-icon-upload2'"
      :style="butType.style || ''"
      >{{ text }}</el-button
    >
  </el-upload>
</template>

<script>
import Token from '@/utils/cache/TokenCache.js'
import { Loading } from 'element-ui'
import tools from '@/utils/tools.js'
export default {
  name: 'CustomUpload',
  props: {
    uploadUrl: {
      type: String,
      required: true,
    },
    butType: {
      type: Object,
      default: () => ({}),
    },
    text: {
      type: String,
      default: '上传文件',
    },
  },
  data() {
    return {
      token: 'Bearer ' + Token.getToken(),
      fileList: [],
      loadingInstance: null,
    }
  },
  methods: {
    beforeUpload(file) {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: '上传中...',
      })
    },
    handleExceed(files, fileList) {
      this.$notify.warning(`已选择文件，请先删除后上传`)
    },
    handleSuccess(res, file) {
      this.loadingInstance.close()
      if (res.Success) {
        this.$emit('success', { res, file })
        this.$notify.success(res.Msg)
        if (res.Data && res.Data.fileUrl) {
          // window.open(res.Data.fileUrl);
          tools.downloadUrl(res.Data.fileUrl, res.Data.fileName)
        }
      } else {
        this.$notify.error(res.Msg)
      }
      console.log(res, 'response')
    },
    handleError(err, file) {
      this.loadingInstance.close()
      console.log(err, 'err')
      this.$notify.error('导入失败')
      this.$emit('upload-error', { err, file })
    },
  },
}
</script>

<style scoped>
.upload-demo {
  display: inline-block;
}
</style>
